import {ScrollLeftAnimation} from './animations/ScrollLeftAnimation';
import {TimeoutPromise} from './promises/TimeoutPromise';

export class Slider {

    private autoType:string='';
    private autoStep:number=0;
    private loop:boolean=true;
    private snap:boolean=true;
    private target?:HTMLElement;
    private pointerId?:number;
    private offsetX?:number;
    private currentX?:number;
    private scrollX:number=0;
    protected down?:number;
    private intervalId:ReturnType<typeof setInterval> | undefined;
    protected dragging:boolean=false;
    protected moving:boolean=false;
    private pane!:JQuery<HTMLElement>;
    private align:string='left';
    private currentScrollX?:number;
    private currentAnimation?:ScrollLeftAnimation;
    private currentAnimationIndex?:number;
    private dragThreshold:number=10;
    private dragEnabled:boolean=false;
    private alignWidth:number=0;

    private kineticIntervalId:ReturnType<typeof setInterval> | undefined;
    private kineticTimestamp?:number;
    private kineticOffset?:number;
    private kineticScrolling:boolean=false;
    private kineticAmplitude?:number;
    private kineticTarget?:number;
    private kineticVelocity?:number;
    private kineticDirection?:number;
    private kineticEventSmoothing?:number;
    private kineticInertia?:number;

    public static instances:Slider[]=[];

    constructor (protected container:JQuery) {
        for (var inst of Slider.instances) {
            if (inst.container.is(container)) return inst;
        }

        this.pane=this.container.find('.slider-pane');
        this.autoType=<string>this.css('auto-type','','string');
        this.autoStep=Number(this.css('auto-step','1px','width'));
        this.alignWidth=Number(this.css('align-width','0px','width'));
        this.loop=<boolean>this.css('loop','true','bool');
        this.snap=<boolean>this.css('snap','true','bool');
        this.align=<string>this.css('align','left','string');
        this.kineticEventSmoothing=<number>this.css('kinetic-event-smoothing','0','float');
        this.kineticInertia=<number>this.css('kinetic-inertia','0','float');
        let index=Number(this.css('index','0','int'));
        let children=this.pane.children().not('.from,.to');
        if (index<0) index=children.length+index;
        let attrIndex=this.pane.attr('data-index');
        if (typeof attrIndex=='string') index=Number(attrIndex);
        let indexPane=children.eq(index);
        let indexOffset=this.getElementOffset(indexPane);
        this.pane.attr('data-index',index);
        this.pane.scrollLeft(indexOffset??0);

        if (this.pane.is(':visible')) {
        let ce=this.getCenterElement();
        ce.addClass('center');
        }

        this.pane.on('scroll',()=>{this.update()});

        if (this.css('wheel-enabled','false','bool')) {
            this.pane.on('wheel',(evt)=>this.wheel(evt));
        }

        this.startTimer();

        this.container.find('.slider-prev').on('click',()=>this.prev());
        this.container.find('.slider-next').on('click',()=>this.next());
        this.container.find('.slider-first').on('click',()=>this.first());
        this.container.find('.slider-last').on('click',()=>this.last());

        this.dragThreshold=Number(this.css('drag-threshold','10','int'));
        this.dragEnabled=<boolean>this.css('drag-enabled','true','bool');
        if (this.dragEnabled) {
            this.pane.css('touch-action','pan-y');
            this.pane.on('pointerdown',(ev)=>this.onpointerdown(ev));
            this.pane.on('pointermove',(ev)=>this.onpointermove(ev));
            this.pane.on('pointerup',(ev)=>this.onpointerup(ev));
            this.pane.on('pointercancel',(ev)=>this.onpointercancel(ev));

            this.pane[0].addEventListener('click',(ev)=>this.onclick(ev),true);
        }

        this.pane.on('focusin',(ev)=>{this.focusin(ev)});
        this.pane.on('focusout',(ev)=>{this.focusout(ev)});
        this.pane.on('keydown',(ev)=>{this.keydown(ev)});

        this.init();

        new ResizeObserver(()=>this.onresize()).observe(this.pane[0]);

        Slider.instances.push(this);
    }

    private async init() {
        await this.onresize();
        this.container.addClass('slider-ready');
    }

    private focusSlide(slide:JQuery<HTMLElement>,direction=0) {
        let rrc=this.pane[0].getBoundingClientRect();
        let rc=slide[0].getBoundingClientRect();
        let ani;
        if (rc.left<rrc.left || rc.right>rrc.right) {
            ani=this.scrollToElement(slide,direction);
        }
        let done=()=>{
            slide.focus();
        };
        if (ani) ani.on('end',done); else done();
    }

    private keydown(ev:JQuery.TriggeredEvent) {
        if (!document.activeElement) return;
        let e=$(document.activeElement);
        if (e.hasClass('slider-item')) {
            if (ev.key=='ArrowLeft') {
                ev.preventDefault();
                let prevItem=e.prev('.slider-item');
                if (!prevItem.length) prevItem=e.nextAll('.slider-item').last();
                this.focusSlide(prevItem,-1);
            }
            if (ev.key=='ArrowRight') {
                ev.preventDefault();
                let nextItem=e.next('.slider-item');
                if (!nextItem.length) nextItem=e.prevAll('.slider-item').last();
                this.focusSlide(nextItem,1);
            }
            if (ev.key=='ArrowDown') {
                ev.preventDefault();
                let allTabbables=this.getTabbableElements($('body')).not('[tabindex=-1],:hidden');
                let looking=false;
                for (let allTabbable of allTabbables) {
                    if (!looking && this.container.has(allTabbable).length) {
                        looking=true;
                    }
                    if (looking && !this.container.has(allTabbable).length) {
                        allTabbable.focus();
                        break;
                    }
                }
            }
            if (ev.key=='Enter') {
                ev.preventDefault();
                this.thawTabIndex(e);
                let tabbableElements=this.getTabbableElements(e).filter(':visible').not('[tabindex=-1]');
                if (tabbableElements.length) {
                    tabbableElements[0].focus({preventScroll:true});
                }
                this.updateTabIndexes();
            }
        }
    }

    private updateAriaDescribedBy() {
        let adb=this.container.find('[role="application"]').attr('aria-describedby');
        if (!adb) return;
        let btmEl=$('#'+adb);
        if (!btmEl.length) return;
        let classes=(btmEl.attr('class')??'').split(/\s+/);
        if (!classes.length) return;
        let sel='.'+classes.join('.');
        let el=this.container.find(sel);
        if (el.length) return el;
        let newEl=btmEl.clone().removeAttr('id');
        this.container.prepend(newEl);
    }

    private async focusin(ev:JQuery.FocusInEvent) {
        let e=$(ev.target);
        if (e.hasClass('slider-item')) this.freezeTabIndex(e);
        if (e.is(':focus-visible')) {
            this.updateAriaDescribedBy();
            await new TimeoutPromise(1);
            this.container.addClass('focus-visible');
            this.stopTimer();
        }
    }

    private focusout(ev:JQuery.FocusOutEvent) {
        if (ev.relatedTarget) {
            this.updateAriaDescribedBy();
            this.container.removeClass('focus-visible');
            this.startTimer();
        }
    }

    private getTabbableElements(e:JQuery<Element>) {
        return e.find('a[href],area[href],input,select,textarea,button,iframe,object,embed,[tabindex],[contenteditable]');
    }

    private freezeTabIndex(e:JQuery<HTMLElement>) {
        let tabbableElements=this.getTabbableElements(e);
        for (let tabbableElement of tabbableElements) {
            let e=$(tabbableElement);
            if (e.data('tabindex')===undefined) {
                e.data('tabindex',e.attr('tabindex')??null);
                e.attr('tabindex',-1);
            }
        }
    }

    private thawTabIndex(e:JQuery<Element>) {
        let tabbableElements=this.getTabbableElements(e);
        for (let tabbableElement of tabbableElements) {
            let e=$(tabbableElement);
            if (e.data('tabindex')!==undefined) {
                e.attr('tabindex',e.data('tabindex'));
                e.removeData('tabindex');
            }
        }
    }

    private startTimer() {
        if (this.intervalId) return;
        let duration=this.css('auto-duration','0','duration');
        if (duration) {
            this.intervalId=setInterval(()=>this.autoTimer(),Math.round(Number(duration)));
        }
    }

    private stopTimer() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            delete this.intervalId;
        }
    }

    private getGap() {
        let gap=this.pane.css('gap');
        if (!gap || !gap.endsWith('px')) return 0;
        return parseInt(gap);
    }

    private updateScrollability() {
        let sw=this.pane[0].scrollWidth;
        if (this.loop) {
            this.container.removeClass('slider-cant-loop');
            let pw=this.pane.width()??0; //We can only properly calculate the pane width AFTER we've removed slider-cant-loop
            let items=this.container.find('.slider-item');
            let lw=0;
            let aw=0;
            let gap=this.getGap();
            let count=items.length;

            for (let k=0;k<count;k++) {
                let itemx=$(items[k]);
                let itemw=itemx.width()??0;
                if (k==(count-1)) {
                    aw+=itemw;
                    break;
                }
                lw+=itemw+gap;
                aw+=itemw+gap;
            }
            if (this.alignWidth) {
                this.container.toggleClass(['slider-cant-loop'],(lw-gap<pw) && (aw>pw));
            }
            let scrollable=(lw-gap>=pw-1);
            this.container.toggleClass(['slider-scrollable','slider-scrollable-prev','slider-scrollable-next'],scrollable);
            if (!scrollable) {
                items.css('order','');
            }
        } else {
            let pw=this.pane.width()??0;
            let sl=this.pane.scrollLeft()??0;
            this.container.toggleClass('slider-scrollable',(sl>0) || (sl<(sw-pw-1)));
            this.container.toggleClass('slider-scrollable-prev',sl>0);
            this.container.toggleClass('slider-scrollable-next',sl<(sw-pw-1));
        }
    }

    private autoTimer() {
        if (this.autoType=='marquee') {
            let direction=Math.sign(this.autoStep);
            let newx=(this.pane.scrollLeft()??0)+this.autoStep;
            this.update();
            let diff=this.reorder(direction,newx);
            newx+=diff;
            this.pane.scrollLeft(newx);
            return;
        }
        this.next();
    }

    private css(prop:string,def:string,type:string='string') {
        let r=this.container.css('--slider-'+prop);
        if (typeof r=='string') r=r.trim();
        if (r===undefined) r=def;
        if (type=='width') {
            let sw=this.container.width();
            let mdiv=$('<div>',{css:{position:'absolute',width:sw+'px'}});
            let minner=$('<div>',{css:{position:'absolute',width:r}});
            mdiv.append(minner);
            this.container.append(mdiv);
            var computed=minner.width();
            mdiv.remove();
            return computed;
        }
        if (type=='float') {
            if (r.match(/(%)$/)) return parseFloat(r)/100;
            return parseFloat(r);
        }
        if (type=='duration') {
            if (r.match(/(ms)$/)) return parseFloat(r);
            if (r.match(/(s)$/)) return parseFloat(r)*1000;
            return parseFloat(r);
            }
        if (type=='bool') {
            if (r=='false') return false;
            if (r=='true') return true;
            throw 'Invalid boolean property value for property "'+prop+'"';
        }
        return r;
    }

    public scrollToIndex(index:number,force:boolean=false) {
        let ce=this.pane.find('>.center');
        let ceidx=ce.index();
        this.removeLazyLoading();
        this.scrollToElement(this.pane.children('.slider-item').eq(index),index>ceidx?1:-1,force);
    }

    public first() {
        this.scrollToElement(this.pane.children('.slider-item').first(),-1);
    }

    public last() {
        this.scrollToElement(this.pane.children('.slider-item').last(),1);
    }

    protected removeLazyLoading(el?:JQuery) {
        if (!el) el=this.pane;
        let lazies=el.find('[loading="lazy"]');
        for (let lazy of lazies) {
            $(lazy).removeAttr('loading');
        }
    }

    public next() {
        let ce=this.getElement();
        let ne=ce.next('.slider-item');
        if (!ne.length && this.loop) ne=this.pane.children('.slider-item').first();

        let le=this.getLastPartiallyVisibleElement();
        le=le.next('.slider-item');
        if (!le.length && this.loop) le=this.pane.children('.slider-item').first();
        this.removeLazyLoading(le);

        this.scrollToElement(ne,1,true);
    }

    public prev() {
        let ce=this.getElement();
        let ne=ce.prev('.slider-item');
        if (!ne.length && this.loop) ne=this.pane.children('.slider-item').last();

        let fe=this.getFirstPartiallyVisibleElement();
        fe=fe.prev('.slider-item');
        if (!fe.length && this.loop) fe=this.pane.children('.slider-item').last();
        this.removeLazyLoading(fe);

        this.scrollToElement(ne,-1,true);
    }

    private wheel(evt:JQuery.TriggeredEvent) {
        evt.preventDefault();
        if (this.currentAnimation) return;
        if (!evt.originalEvent) return;
        const wheelEvent = evt.originalEvent as WheelEvent;

        let ce=this.getElement();
        let ne=(wheelEvent.deltaY>0)?ce.next('.slider-item'):ce.prev('.slider-item');
        if (!ne.length) {
            if (!this.loop) return;
            let items=this.pane.find('.slider-item');
            ne=(wheelEvent.deltaY>0)?items.first():items.last();
        }

        this.scrollToElement(ne,(wheelEvent.deltaY>0)?1:-1);
    }

    private getElementOffset(el:JQuery<HTMLElement>) {
        let sx=this.pane[0].scrollLeft;
        let rrc=this.pane[0].getBoundingClientRect();
        let rc=el[0].getBoundingClientRect();
        let left=sx+rc.left-rrc.left;
        let paneWidth=rrc.width;
        if (this.alignWidth) left-=(paneWidth-this.alignWidth)/2;

        if (this.align=='center') {
            let mid=(this.pane.width()??0)/2;
            return left+rc.width/2-mid;
        }

        if (this.align=='left') {
            return left;
        }

        assert(false);
    }

    private getDirection(el:JQuery<HTMLElement>) {
        let items=this.pane.find('.slider-item');
        let count=items.length;
        let ce=this.pane.find('>.center');
        let ceidx=ce.index();
        let elidx=el.index();

        let right_diff=(elidx-ceidx);
        if (right_diff<0) right_diff+=count;

        let left_diff=(ceidx-elidx);
        if (left_diff<0) left_diff+=count;

        return (right_diff<left_diff)?1:-1;
    }

    protected scrollToElement(el:JQuery<HTMLElement>,direction=0,force=false) {
        if (!el.length) return;
        if (this.kineticScrolling) return;

        let index=el.index();
        if (this.currentAnimation) {
            if (this.currentAnimationIndex==index) return;
            this.currentAnimation.stop();
        }

        let curx=this.pane.scrollLeft()??0;
        if (!direction) direction=this.getDirection(el);
        let diff=this.reorder(direction,curx);
        curx+=diff;

        let pw=this.pane.width();
        assert(pw!==undefined);
        let ew=el.width()??0;

        let newx=this.getElementOffset(el);
        let tweenEnd=newx;  //Manage our own tween end to allow negative values
        if (newx<0) newx=0;
        this.stopTimer();
        this.pane.attr('data-index',index);
        if (curx==newx) return;

        if (newx>curx && newx+ew<curx+pw && !force) return;

        this.container.trigger('slider.scroll.start',{index});
        this.container.addClass('sliding');

        this.currentAnimationIndex=index;
        this.currentAnimation=new ScrollLeftAnimation(this.pane)
            .to(newx)
            .play()
            .on("end stop", ()=>{
                this.startTimer();
                this.currentAnimation=undefined;
                this.currentAnimationIndex=undefined;
                this.container.trigger('slider.scroll.stop',{index});
                this.container.removeClass('sliding');
                this.updateTabIndexes();
            })
            .on("step", (opts:any)=>{
                this.update();
                let diff=this.reorder(direction,opts.tween.now);
                tweenEnd+=diff;
                opts.tween.start+=diff;
                opts.tween.end=tweenEnd;
                opts.tween.now+=diff;
            });
            return this.currentAnimation;
    }

    public getElement() {
        if (this.align=='center') return this.getCenterElement();
        if (this.align=='left') return this.getLeftElement();
        assert(false);
    }

    private getFirstFullyVisibleElement():JQuery<HTMLElement> {
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_element;
        let paneLeft=rrc.left;
        let paneWidth=rrc.width;
        this.pane.children('.slider-item').each(
            (idx,e)=>{
                let r=e.getBoundingClientRect();
                let left=r.left-paneLeft;
                if ((left>=0) && (best===false || left<best)) {
                    best=left;
                    best_element=e;
                }

            }
        );
        assert(best_element);
        return $(best_element);
    }

    private getClosestSnapPosition(pos:number):number {
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_pos=0;
        let paneWidth=rrc.width;

        let sideW=(paneWidth-this.alignWidth)/2;
        if (this.alignWidth) pos+=sideW;

        let sx=this.pane[0].scrollLeft;
        let sw:number=this.pane[0].scrollWidth;

        let gap=this.getGap();
        let shiftPos=pos%(sw+gap);
        let shift=pos-shiftPos;

        this.pane.children('.slider-item').each(
            (idx,el)=>{
                let rc=el.getBoundingClientRect();
                let xpos=sx+rc.left-rrc.left;
                if (this.align=='center') xpos+=rc.width/2;
                let diff=xpos-pos;

                if (best===false || Math.abs(diff)<best) {
                    best=Math.abs(diff);
                    best_pos=xpos+shift;
                }

            }
        );

        if (this.alignWidth) best_pos-=sideW;

        return best_pos;
    }

    private getFirstPartiallyVisibleElement():JQuery<HTMLElement> {
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_element;
        let paneLeft=rrc.left;
        let paneWidth=rrc.width;
        this.pane.children('.slider-item').each(
            (idx,e)=>{
                let r=e.getBoundingClientRect();
                let right=r.right-paneLeft;
                if ((right>=0) && (best===false || right<best)) {
                    best=right;
                    best_element=e;
                }

            }
        );
        assert(best_element);
        return $(best_element);
    }

    private getLastPartiallyVisibleElement():JQuery {
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_element;
        let paneLeft=rrc.left;
        let paneWidth=rrc.width;
        this.pane.children('.slider-item').each(
            (idx,e)=>{
                let r=e.getBoundingClientRect();
                let left=r.left-paneLeft;
                let right=r.right-paneLeft;
                if ((right>=0) && (left<=paneWidth) && (best===false || left>best)) {
                    best=left;
                    best_element=e;
                }

            }
        );
        assert(best_element);
        return $(best_element);
    }

    private getLeftElement():JQuery {
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_element;
        let paneLeft=rrc.left;
        let paneWidth=rrc.width;
        if (this.alignWidth) paneLeft+=(paneWidth-this.alignWidth)/2;
        this.pane.children('.slider-item').each(
            (idx,e)=>{
                let r=e.getBoundingClientRect();
                let diff=Math.abs(r.left-paneLeft);
                if (best===false || diff<best) {
                    best=diff;
                    best_element=e;
                }

            }
        );
        assert(best_element);
        return $(best_element);
    }

    private getCenterElement():JQuery {
        let panew=this.pane.width();
        assert(panew);
        let mid=panew/2;
        let rrc=this.pane[0].getBoundingClientRect();
        let best:false|number=false;
        let best_element;
        this.pane.children('.slider-item').each(
            (idx,e)=>{
                let r=e.getBoundingClientRect();
                let rc=r.left+r.width/2-rrc.left;
                let diff=Math.abs(rc-mid);
                if (best===false || diff<best) {
                    best=diff;
                    best_element=e;
                }

            }
        );
        assert(best_element);
        return $(best_element);
    }

    private updateTabIndexes() {
        let paneOffset=this.pane.offset();
        assert(paneOffset)
        let paneLeft=paneOffset.left;
        let panew=this.pane.width();
        assert(panew!==undefined);
        let items=this.pane.find('.slider-item');
        for (let k=0;k<items.length;k++) {
            let itemx=$(items[k]);
            let itemxOffset=itemx.offset();
            let itemxWidth=itemx.width();
            assert(itemxOffset!==undefined && itemxWidth!==undefined);
            let left=itemxOffset.left-paneLeft;
            let right=left+itemxWidth;
            let isVisible=(right>=0) && (left<panew);
            let prevItem=(k>0)?items[k-1]:items[items.length-1];
            let hasFocus=Boolean($(prevItem).has(':focus-visible').length);
            if (!isVisible && !hasFocus) itemx.attr('inert','inert'); else itemx.removeAttr('inert');
        }
    }

    private updateSlideDimensions() {
        let paneOffset=this.pane.offset();
        assert(paneOffset!==undefined);
        let paneLeft=paneOffset.left;
        let items=this.pane.find('.slider-item');
        this.pane.css('--slider-pane-left',paneLeft);
        for (let item of items) {
            let itemx=$(item);
            let itemxOffset=itemx.offset();
            assert(itemxOffset!==undefined);
            itemx.css('--slider-slide-width',itemx.width()+'px');
            itemx.css('--slider-slide-left',(itemxOffset.left-paneLeft)+'px');
        }
    }

    private update() {
        this.currentScrollX=this.pane.scrollLeft();

        this.updateSlideDimensions();

        let ce=this.getElement();
        let curcenter=this.pane.find('>.center');
        if (!curcenter.is(ce)) {
            curcenter.removeClass('center');
            ce.addClass('center');
            this.container.trigger('slider.change',{index:ce.index()});
        }

        this.updateScrollability();
    }

    private reorder(direction:number,newX:number):number {
        if (!this.loop) return 0;

        let items=this.pane.find('.slider-item');
        let count=items.length;
        let panew=this.pane.width();
        assert(panew!==undefined);
        let mw=this.pane[0].scrollWidth-panew;
        let curcenter;
        if (this.alignWidth) {
            curcenter=this.getFirstFullyVisibleElement();
        } else {
            curcenter=this.getLeftElement();
        }

        let curcenterOffset=curcenter.offset();
        assert(curcenterOffset!==undefined);

        let pos=this.pane[0].scrollLeft;
        let posBefore=curcenterOffset.left;

        let sidew=(this.alignWidth>0)?(panew-this.alignWidth)/2:0;

        let errorMargin=2;
        if (direction<0) {
            if (newX>sidew+errorMargin) return 0;
        } else {
            if (newX<mw-sidew-errorMargin) return 0;
        }

        let idx=items.index(curcenter);

        let tw=0;
        let order=0;
        let gap=this.getGap();

        for (let k=0;k<count;k++) {
            let item=items.eq((idx+k)%count);
            let iw=item.width();
            assert(iw!==undefined);
            if (k>0) iw+=gap;
            tw+=iw;
            if (tw>=panew+mw/2 && order>=0) {
                if (direction<0 || this.alignWidth>0) {
                    order=-(count-k);
                }
            }
            item.css('order',order);
            order++;
        }

        let curcenterOffsetAfter=curcenter.offset();
        assert(curcenterOffsetAfter!==undefined);

        let posAfter=curcenterOffsetAfter.left;
        let posDiff=posAfter-posBefore;

        this.pane[0].scrollLeft+=posDiff;
        this.scrollX+=posDiff;
        return posDiff;
    }

    private onpointermove(ev:JQuery.TriggeredEvent) {
        if (!this.dragging) return;
        if (this.kineticScrolling) return;
        if (ev.pointerId!=this.pointerId) return;
        assert(this.offsetX!==undefined && ev.pageX!==undefined);
        ev.preventDefault();
        let r=this.pane[0].getBoundingClientRect();
        this.currentX=ev.pageX;
        let diff=this.offsetX-ev.pageX;
        if (!this.container.hasClass('slider-scrollable-prev') && diff<0) diff=0;
        if (!this.container.hasClass('slider-scrollable-next') && diff>0) diff=0;

        if (!this.moving && Math.abs(diff)<this.dragThreshold) return;
        this.moving=true;
        let curX=this.pane.scrollLeft();
        assert(curX!==undefined);
        let newX=diff+this.scrollX;
        let reorderDiff=this.reorder(Math.sign(newX-curX),newX);
        newX+=reorderDiff;
        this.pane.scrollLeft(newX);
    }

    private async onresize() {
        this.alignWidth=Number(this.css('align-width','0px','width'));
        let index=Number(this.pane.attr('data-index'));
        let children=this.pane.children().not('.from,.to');
        let indexPane=children.eq(index);
        let left=indexPane[0].offsetLeft-this.pane[0].offsetLeft;
        if (this.align=='center') {
            left=this.getElementOffset(indexPane);
        }
        let diff=0;
        if (this.alignWidth>0) {
            let panew=this.pane.width();
            assert(panew!==undefined);
            let sidew=(panew-this.alignWidth)/2;
            left-=sidew;
            diff=this.reorder(-1,left);
            await new TimeoutPromise(1);
        }
        this.pane.scrollLeft(left+diff);
        this.updateScrollability();
        this.updateTabIndexes();
        this.updateImageCenter();
        this.updateSlideDimensions();

        //Chrome sometimes doesn't lazy load the first
        //partially visible item so we force it here.
        let fe=this.getFirstPartiallyVisibleElement();
        this.removeLazyLoading(fe);
    }

    private updateImageCenter() {
        let slides=this.container.find('.slider-item');
        let minTop=Number.MAX_SAFE_INTEGER;
        let maxBottom=0;
        for (let slide of slides) {
            let img=this.getLargestImage($(slide));
            if (!img) continue;
            let rc=img[0].getBoundingClientRect();
            if (rc.top<minTop) minTop=rc.top;
            if (rc.bottom>maxBottom) maxBottom=rc.bottom;
        }
        let rrc=this.pane[0].getBoundingClientRect();
        let center=(minTop+maxBottom)/2-rrc.top;
        this.container.css('--slider-image-center',Math.round(center)+'px');
    }

    private getLargestImage(slide:JQuery<HTMLElement>) {
        let imgs=slide.find('img');
        let maxHeight=-1;
        let maxImage=null;
        for (let img of imgs) {
            let rc=img.getBoundingClientRect();
            if (rc.height>maxHeight) {
                maxHeight=rc.height;
                maxImage=$(img);
            }
        }
        return maxImage;
    }

    private onpointerdown(ev:JQuery.TriggeredEvent) {
        if (ev.button!=0) return;

        if (!$(ev.target).closest('.slider-pane').length) return;

        let sw=this.pane[0].scrollWidth;
        let pw=this.pane.width();
        assert(pw!==undefined);
        if (sw<=pw) return;

        ev.preventDefault();
        if (this.currentAnimation) return;

        if (this.dragging) {
            if (this.kineticScrolling) {
                this.kineticScrolling=false;
            } else {
                return;
            }
        } else {
            this.kineticVelocity=0;
        }

        this.removeLazyLoading();

        this.dragging=true;
        this.moving=false;
        if (this.down) clearTimeout(this.down);
        this.down=window.setTimeout(()=>{this.down=undefined;},200);
        this.pointerId=ev.pointerId;
        this.target=ev.target;
        assert(this.target!=undefined && ev.pointerId!=undefined);
        this.target.setPointerCapture(ev.pointerId);
        this.offsetX=ev.pageX;
        this.currentX=ev.pageX;
        this.scrollX=this.pane[0].scrollLeft;
        this.stopTimer();
        this.kineticTrackingStart();
    }

    private kineticTrackingStart() {
        this.kineticTimestamp=Date.now();
        this.kineticOffset=this.currentX;
        this.kineticIntervalId=setInterval(()=>this.kineticTrackingMeasure(),10);
    }

    private kineticTrackingStop() {
        if (this.kineticIntervalId) clearInterval(this.kineticIntervalId);
        delete this.kineticIntervalId;
    }

    private kineticTrackingMeasure() {
        let now=Date.now();
        assert(this.kineticTimestamp!==undefined && this.kineticOffset!==undefined && this.currentX!==undefined);
        assert(this.kineticEventSmoothing!==undefined && this.kineticVelocity!==undefined);
        let elapsed=(now-this.kineticTimestamp)/1000;
        let distance=this.kineticOffset-this.currentX;
        this.kineticTimestamp=now;
        this.kineticOffset=this.currentX;
        let v=distance/elapsed;
        // Simple exponential smoothing algorithm to smoothen out
        // jerky mouse movements a bit: Recent historic events are
        // also considered - not only the most recent events but
        // they are faded out exponentially to avoid very old events
        // to influence the current velocity.
        let alpha=this.kineticEventSmoothing;
        this.kineticVelocity=((1-alpha)*v)+(alpha*this.kineticVelocity);
    }

    private onpointercancel(ev:JQuery.TriggeredEvent) {
        if (!this.dragging) return;
        if (ev.pointerId!=this.pointerId) return;
        this.dragging=false;
        this.kineticTrackingStop();
        this.startTimer();
    }

    private onclick(ev:PointerEvent) {
        if (this.moving) {
            ev.preventDefault();
            ev.stopPropagation();
            this.moving=false;
        }
    }

 private kineticScrollingStart() {
        assert(this.kineticInertia!==undefined && this.kineticVelocity!==undefined);
        let amplitude=this.kineticInertia*this.kineticVelocity;
        this.kineticDirection=Math.sign(amplitude);
        let offset=this.pane.scrollLeft();
        let panew=this.pane.width();
        assert(offset!==undefined && panew!==undefined);
        if (this.align=='center') offset+=panew/2;
        let target=Math.round(offset+amplitude);
        let direction=Math.sign(amplitude);
        this.kineticTarget=this.getClosestSnapPosition(target);
        this.kineticAmplitude=this.kineticTarget-offset;
        this.kineticTimestamp=Date.now();
        this.kineticScrolling=true;
        requestAnimationFrame(()=>this.kineticScrollingRun());
    }

    private kineticScrollingRun() {
        if (!this.kineticScrolling) return;
        assert(this.kineticTimestamp!==undefined && this.kineticAmplitude!==undefined && this.kineticTarget!==undefined);
        assert(this.kineticDirection!==undefined);

        let panew=this.pane.width();
        assert(panew);
        let timeConstant = 325;
        let elapsed = Date.now() - this.kineticTimestamp;
        let delta = -this.kineticAmplitude * Math.exp(-elapsed / timeConstant);
        if (delta > 0.5 || delta < -0.5) {
            let newX=this.kineticTarget + delta;
            let diff=this.reorder(this.kineticDirection,newX);
            newX+=diff;
            if (this.align=='center') newX-=panew/2;
            this.pane.scrollLeft(newX);
            this.kineticTarget+=diff;
            requestAnimationFrame(()=>this.kineticScrollingRun());
        } else {
            let newX=this.kineticTarget;
            let diff=this.reorder(this.kineticDirection,newX);
            newX+=diff;
            if (this.align=='center') newX-=panew/2;
            this.pane.scrollLeft(newX);
            this.updateTabIndexes();
            this.dragging=false;
            this.kineticScrolling=false;
            this.startTimer();
        }
    }

    private onpointerup(ev:JQuery.TriggeredEvent) {
        if (ev.button!=0) return;
        if (!this.dragging) return;
        if (this.kineticScrolling) return;
        if (ev.pointerId!=this.pointerId) return;

        this.kineticTrackingStop();
        this.kineticScrollingStart();

        ev.preventDefault();
    }

    static {
        window.addEventListener('pagehide',()=>{
            $('.slider-pane').each(
                (idx,e)=>{
                    e.scrollTo({left:0});
                }
            );
        });
    }

}

export {};